import React from 'react';

import { Button, Popover, Radio } from 'antd';

import BookingCalendar, { AvailableDate, CombinedTime } from '../../model/BookingCalendar';
import Flex from '../StyledComponents/Flex';
import './RequestAgenda.css';
import { useTranslation } from '@nic-react-i18n/core';
import dayjs from 'dayjs';
/*
interface StateInterface {
    selectedValue: number;
    visible: boolean;
    error: boolean;
    errorMessage?: string;
}
*/
interface RequestAgendaItemInterface extends React.PropsWithChildren{
    selectedDate: dayjs.Dayjs;
    calendar: BookingCalendar;
   // content: React.ReactNode;
    bookDate: (date: string) => void;
    children: React.ReactElement
}
type RequestAgendaItemProps = RequestAgendaItemInterface

interface ErrorInterface {
    message: string;
}

const ErrorMessage: React.FC<ErrorInterface> = (props) => {
    return (
        <Flex
            direction={'row'}
            align={'center'}
            justify={'center'}
            className={'padding-top-10'}
        >
            <div>
                <span className={'red padding-top-5'}><i className={'fas fa-exclamation-circle'}/></span>
                <span className={'padding-left-5'}>{props.message}</span>
            </div>
        </Flex>
    );
};

const RequestAgendaItem: React.FC<RequestAgendaItemProps> = (props) => {

    const [selectedValue, setSelectedValue] = React.useState(-1)
    const [visible, setVisible] = React.useState(false)
    const [error, setError] = React.useState(false)

    const {t} = useTranslation()

    // "testDate": "2018-01-07T16:30:00+01:00"

    const buildBookingDate = (calendar: BookingCalendar, date: dayjs.Dayjs, time: number): string => {

        let formattedDate = date.format('YYYY-MM-DD');

        let selectedAvailableDate: AvailableDate = (calendar.availability as any)[formattedDate];

        let res = selectedAvailableDate.times[time].original;

        return res;
    }

    const renderDialog = (selectedDate: dayjs.Dayjs, calendar: BookingCalendar) => {

        let choices: Array<React.ReactElement<any>> = new Array<React.ReactElement<any>>();
        let i = 0;

        let formattedDate = selectedDate.format('YYYY-MM-DD');

        // let localeTime: string = moment().format('HH:mm');
        // let registryTime: string = momentTZ().tz('Europe/Rome').format('HH:mm');

        // let timeMismatch = (localeTime !== registryTime);

        let selectedAvailableDate: AvailableDate = (calendar.availability as any)[formattedDate];

        if (selectedAvailableDate) {
            selectedAvailableDate.times.forEach((complexTime: CombinedTime, index: number) => {
                const splitted = complexTime.time.split(':');
                const realValue = splitted[0] + ':' + splitted[1];
                choices.push(
                    <Radio.Button
                        key={i++}
                        value={index}
                        defaultChecked={false}
                    >
                        <i className="fal fa-clock padding-right-5 margin-top-20"/>
                        {realValue}
                    </Radio.Button>
                );
            });
        }
        return (
            <div>
                <Flex
                    direction={'row'}
                    justify={'flex-start'}
                    align={'center'}
                    className={'padding-5'}
                    style={{border: '1px dashed orange', marginBottom: '10px'}}
                >
                    <span><i style={{color: 'orange'}} className={'fas fa-exclamation-triangle'}/></span>
                    <span className="pl-5" >{t('message.cet')}</span>
                </Flex>

                <div>
                    <label>{t('request.calendar.booking.availableTimes')}</label>
                </div>
                <div>
                    <Radio.Group
                        defaultValue={'none'}
                        size={'small'}
                        onChange={(e) => {
                            setSelectedValue(Number(e.target.value))
                            setError(false);
                        }}
                    >
                        {choices}
                    </Radio.Group>
                </div>

                {error &&
                    <ErrorMessage message={t('request.calendar.booking.empty')}/>
                }
                <Flex
                    direction={'row'}
                    justify={'space-between'}
                    className={'padding-top-20'}
                >
                    <Button
                        size={'small'}
                        onClick={() => {setVisible( false);
                        }}
                    >
                        {t('request.calendar.booking.button.cancel')}
                    </Button>
                    <Button
                            size={'small'}
                            onClick={() => {

                                if (selectedValue >= 0) {
                                    const bookDate = buildBookingDate(calendar, selectedDate, selectedValue);
                                    props.bookDate(bookDate);
                                    setVisible(false)
                                } else {
                                    setError(true)
                                }
                            }}
                    >
                        {t('request.calendar.booking.button.ok')}
                    </Button>
                </Flex>
            </div>
        );
    }


        const {selectedDate,  calendar, children} = props;

        let title = dayjs(selectedDate).format('dddd DD MMMM YYYY');

        let innerComponent = renderDialog(selectedDate, calendar);

        return (
            <Popover
                content={innerComponent}
                title={title}
                open={visible}
                onVisibleChange={(visible) => {
                    setVisible(visible)
                    setError( false);
                }}
                trigger={'click'}
            >
                {children}
            </Popover>
        );

}
export default RequestAgendaItem